const reducer = state => ({
  ...state,
  waiting: false,
});

export default reducer;
